import { render, staticRenderFns } from "./RatingIcons.vue?vue&type=template&id=28ba62b9&"
import script from "./RatingIcons.vue?vue&type=script&lang=js&"
export * from "./RatingIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports